<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu></zestawieniaMenu>

        <div class="widget-heading d-flex justify-content-between align-items-center">
          <h4 class="my-0">Okulary</h4>
		  <div class="d-flex gap-2">
            <button class="btn btn-success" @click="openAddModal">
              <i class="bi bi-plus-lg"></i> Dodaj
            </button>
            <a :href="route('kadry.pracownicy.okulary.pdf')" class="btn btn-info" target="_blank">
              <i class="bi bi-file-earmark-pdf"></i>&nbsp;Lista w PDF
            </a>
		  </div>
		</div>

        <div class="widget-content">
          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th @click="sortBy('userName')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Nazwisko i imię
                    <span v-if="sortKey === 'userName'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('do_kiedy')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Data wpisu
                    <span v-if="sortKey === 'do_kiedy'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('end_data')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Do kiedy
                    <span v-if="sortKey === 'end_data'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th class="bg-gray-100">Opcje</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="okular in sortedOkulary" :key="okular.id">
                  <td class="text-start">{{ okular.userName }}</td>
                  <td class="text-start">{{ okular.do_kiedy }}</td>
                  <td class="text-start">{{ getEndDate(okular.do_kiedy) }}</td>
                  <td>
                    <button class="btn btn-sm btn-primary me-1" @click="openEditModal(okular)">Edytuj</button>
                    <button class="btn btn-sm btn-danger" @click="deleteOkulary(okular.id)">Usuń</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Modal -->
        <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block; background-color: rgba(0,0,0,0.5)">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ isEditing ? 'Edytuj okulary' : 'Dodaj okulary' }}</h5>
                <button type="button" class="btn-close" @click="closeModal"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-label">Pracownik</label>
					<select v-model="form.user_id" class="select2 form-select w-100" id="sel_user_id">
					  <option v-for="user in users" :key="user.id" :value="user.id">
						{{ user.last_name }} {{ user.first_name }}
					  </option>
					</select>
                  </div>
                  <div class="col-md-12 mt-3">
                    <label class="form-label">Do kiedy</label>
                    <input v-model="form.do_kiedy" type="date" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeModal">Anuluj</button>
                <button class="btn btn-success" @click="saveOkulary">{{ isEditing ? 'Zapisz zmiany' : 'Dodaj' }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Koniec modal -->
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from "axios";

export default {
  components: { AppLayout, zestawieniaMenu },
  props: {
    okulary: { type: Array, required: true },
    users: { type: Array, required: true },
  },
  data() {
    return {
      sortKey: "userName",
      sortOrder: "asc",
      isModalOpen: false,
      isEditing: false,
      form: {
        id: null,
        user_id: null,
        do_kiedy: "",
      },
      localOkulary: [],
    };
  },
  computed: { 
    sortedOkulary() {
      return this.localOkulary.slice().sort((a, b) => {
        let aVal = a[this.sortKey];
        let bVal = b[this.sortKey];
        if (typeof aVal === "string") {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }
        if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    }, 
  },
  mounted() {
    this.localOkulary = this.okulary.map(t => ({ ...t }));
  },
  methods: {
  getEndDate(date) {
  if (!date) return '';

  const endDate = new Date(date);
  endDate.setFullYear(endDate.getFullYear() + 3);

  return endDate.toISOString().split('T')[0];
},
	initUserSelect() {
	  this.$nextTick(() => {
		if ($('#sel_user_id').hasClass("select2-hidden-accessible")) {
		  $('#sel_user_id').select2('destroy');
		}

		$('#sel_user_id')
		  .select2({
			dropdownParent: $('.modal')
		  })
		  .val(this.form.user_id || '')  // ustawienie domyślnej wartości
		  .trigger('change')
		  .on('select2:select', (e) => {
			const selectedUserId = parseInt(e.params.data.id);
			this.form.user_id = selectedUserId;
		  });
	  });
	},
    sortBy(key) {
      if (this.sortKey === key) this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      else this.sortKey = key;
    },
    openAddModal() {
      this.isEditing = false;
      this.form = { id: null, user_id: null, do_kiedy: "" };
      this.isModalOpen = true;
	  this.initUserSelect();
    },
openEditModal(okular) {
  this.isEditing = true;
  this.form = {
    id: okular.id, 
    user_id: Number(okular.user_id),
    do_kiedy: okular.do_kiedy,
  };

  this.isModalOpen = true;

  this.$nextTick(() => {
    if ($('#sel_user_id').hasClass("select2-hidden-accessible")) {
      $('#sel_user_id').select2('destroy');
    }
    $('#sel_user_id')
      .select2({
        dropdownParent: $('.modal'),
      })
      .val(this.form.user_id) // ustawiamy domyślną wartość
      .trigger('change')       // odświeżenie Select2
      .on('select2:select', (e) => {
        const selectedUserId = parseInt(e.params.data.id);
        this.form.user_id = selectedUserId;
      });
  });
},
    closeModal() {
      this.isModalOpen = false;
    },
async saveOkulary() {
  try {
    if (this.isEditing) {
      await axios.put(`/kadry/pracownicy/okulary/update/${this.form.id}`, this.form);
      const index = this.localOkulary.findIndex(t => t.id === this.form.id);
      const user = this.users.find(u => u.id === this.form.user_id);
      this.localOkulary[index] = { ...this.form, userName: `${user.first_name} ${user.last_name}` };
    } else {
      const res = await axios.post('/kadry/pracownicy/okulary/add', this.form);
      const user = this.users.find(u => u.id === this.form.user_id);

      // ustawiamy ID nowego rekordu w formie, żeby od razu można edytować
      this.form.id = res.data.id;
     this.form.do_kiedy = res.data.do_kiedy;

      this.localOkulary.push({
        id: res.data.id,
        user_id: this.form.user_id,
        userName: `${user.first_name} ${user.last_name}`,
        do_kiedy: this.form.do_kiedy,
      });
    }

    this.closeModal();
    this.showToast('success', 'Zapisano', 'Dane zostały zaktualizowane.');
  } catch (error) {
    console.error(error);
    this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
  }
},
    async deleteOkulary(id) {
      if (!confirm("Na pewno chcesz usunąć te okulary?")) return;
      try {
        await axios.delete(`/kadry/pracownicy/okulary/del/${id}`);
        this.localOkulary = this.localOkulary.filter(t => t.id !== id);
		this.showToast('success', 'Usunięto', 'Dane zostały usunięte.');
      } catch (error) {
        console.error(error);
        this.showToast('error', 'Błąd', 'Nie udało się usunąć danych.');
      }
    },
	    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  },
};
</script>

<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
</style>